import React, { Component, lazy, Suspense } from "react";
import "./App.css";
import $ from "jquery";
import "./utils/animateCss"; // jQuery plugin for animate.css
import config from "./mp-config.json";

import chi_pm1 from "../assets/planos/chi/pm1.json";
import chi_p1 from "../assets/planos/chi/p1.json";
import chi_p2 from "../assets/planos/chi/p2.json";
import chi_p3 from "../assets/planos/chi/p3.json";

import { loadStores, loadDisccounts } from "./service/service";
import StartView from "./views/StartView";
import MapView from "./views/MapView";

// Get mall ID from URL or default
function setMallId() {
  const urlParams = new URLSearchParams(window.location.search);
  const mallParam = urlParams.get("mall");
  if (mallParam) {
    window.MALL_ID = mallParam;
  }
}

// Setting the mall which to render. Options are pld, pve, poe, peg
let MALL_ID = "chi";
setMallId();

let PISO_1_INDEX = 0;
let START_VIEW = "start";
let MAP_VIEW = "map";

let pm1 = [],
  p0 = [],
  p1 = [],
  p2 = [],
  p3 = [],
  p4 = [];
let currentConf;

class App extends Component {
  constructor(props) {
    super(props);
    currentConf = config.filter(conf => conf.id === MALL_ID)[0];
    this.state = {
      start: false,
      end: false,
      context: false,
      stores: false,
      disccounts: false,
      currentFloor: PISO_1_INDEX,
      mode: START_VIEW,
      config: currentConf,
      to: "",
      from: ""
    };
    switch (currentConf.id) {
      case "chi":
        document.title = "Mapa Interactivo - U de Chile";
        pm1 = chi_pm1;
        p1 = chi_p1;
        p2 = chi_p2;
        p3 = chi_p3;
        break;
      default:
        document.title = "Mapa Interactivo - U de Chile";
        pm1 = chi_pm1;
        p1 = chi_p1;
        p2 = chi_p2;
        p3 = chi_p3;
        break;
    }
  }

  componentDidMount() {
    this.processStores();
    this.processDisccounts();
  }

  processStores() {
    // Extract stores from floor plan JSON files
    const allFloors = [
      { data: pm1, nivel: "-1" },
      { data: p0, nivel: "0" },
      { data: p1, nivel: "1" },
      { data: p2, nivel: "2" },
      { data: p3, nivel: "3" },
      { data: p4, nivel: "4" }
    ];

    let fm1 = [],
      f1 = [],
      f2 = [],
      f3 = [],
      f0 = [],
      f4 = [];

    // Extract stores from each floor's nodes
    allFloors.forEach(floor => {
      if (floor.data && floor.data.length > 0) {
        floor.data.forEach(node => {
          if (node.store && node.store_info) {
            const storeData = {
              id: node.store_info.id,
              title: node.store_info.title,
              nivel: node.store_info.nivel || floor.nivel,
              nodeId: node.id,
              multi_floor: node.store_info.multi_floor,
              multi_floor_id: node.store_info.multi_floor_id,
              qr: node.store_info.qr || ""
            };

            switch (storeData.nivel.trim()) {
              case "-1":
                fm1.push(storeData);
                break;
              case "0":
                f0.push(storeData);
                break;
              case "1":
                f1.push(storeData);
                break;
              case "2":
                f2.push(storeData);
                break;
              case "3":
                f3.push(storeData);
                break;
              case "4":
                f4.push(storeData);
                break;
              default:
                break;
            }
          }
        });
      }
    });

    let stateStores = {
      fm1: fm1.sort((a, b) => a.title > b.title),
      f0: f0.sort((a, b) => a.title > b.title),
      f1: f1.sort((a, b) => a.title > b.title),
      f2: f2.sort((a, b) => a.title > b.title),
      f3: f3.sort((a, b) => a.title > b.title),
      f4: f4.sort((a, b) => a.title > b.title)
    };

    this.setState({
      stores: stateStores
    });
  }

  processDisccounts() {
    // Discounts not available in floor plan data
    // Set empty array or load from separate file if needed
    this.setState({
      disccounts: []
    });
  }

  findNodeById(nodeId) {
    const allNodes = [...pm1, ...p0, ...p1, ...p2, ...p3, ...p4];
    return allNodes.find(node => node.id === nodeId);
  }

  onSelectionFinished(start, end) {
    this.setState({
      start,
      end,
      mode: MAP_VIEW
    });

    $("#startview").animateCss("fadeOut", () => {
      $("#startview").css("display", "none");
    });
    $("#mapview").css("display", "block");
    $("#mapview").animateCss("fadeIn");
  }

  onMapBack() {
    $("#mapview").animateCss("fadeOut", () => {
      $("#mapview").css("display", "none");
    });
    $("#startview").css("display", "block");
    $("#startview").animateCss("fadeIn");
    this.setState({
      start: false,
      end: false,
      mode: START_VIEW
    });
  }

  render() {
    let { stores, start, end, disccounts, config } = this.state;
    return (
      <div id="app" className="App">
        <StartView
          config={config}
          stores={stores}
          start={start}
          end={end}
          pm1={pm1}
          p0={p0}
          p1={p1}
          p2={p2}
          p3={p3}
          p4={p4}
          onSelectionFinished={(start, end) =>
            this.onSelectionFinished(start, end)
          }
        />
        <MapView
          config={config}
          stores={stores}
          disccounts={disccounts}
          start={start}
          end={end}
          pm1={pm1}
          p0={p0}
          p1={p1}
          p2={p2}
          p3={p3}
          p4={p4}
          animate={start && end}
          onBack={() => this.onMapBack()}
        />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js